"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ExpandLessRounded_1 = __importDefault(require("@mui/icons-material/ExpandLessRounded"));
const QListToolbar_1 = __importDefault(require("./QListToolbar"));
const QListHeader_1 = __importDefault(require("./QListHeader"));
const QListDetails_1 = __importDefault(require("./QListDetails"));
const IdGenerator_1 = __importDefault(require("./IdGenerator"));
const styles_1 = __importDefault(require("./styles"));
const sortValue = (val) => {
    if (typeof val === 'string') {
        return val === null || val === void 0 ? void 0 : val.toLowerCase();
    }
    return val;
};
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const QList = (props) => {
    const { classes } = useStyles();
    const idGenerator = new IdGenerator_1.default(props.listItemType);
    const prevData = (0, react_use_1.usePrevious)(props.data);
    const [, forceUpdate] = (0, react_1.useReducer)((val) => val + 1, 0);
    const sizeChanged = () => {
        forceUpdate();
    };
    const doSort = (data, orderBy, order) => {
        const newData = [].concat(data);
        if (order === 'asc') {
            newData.sort((a, b) => (sortValue(b[orderBy]) < sortValue(a[orderBy]) ? -1 : 1));
        }
        else {
            newData.sort((a, b) => (sortValue(a[orderBy]) < sortValue(b[orderBy]) ? -1 : 1));
        }
        return newData;
    };
    const [state, setState] = (0, react_1.useState)({
        order: 'desc',
        orderBy: props.defaultSort,
        selected: [],
        open: [],
        showChildren: [],
        data: doSort(props.data, props.defaultSort, 'desc'),
    });
    const handleRequestSort = (_, property) => {
        let newOrder = 'desc';
        if (state.orderBy === property && state.order === 'desc') {
            newOrder = 'asc';
        }
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { order: newOrder, orderBy: property, data: doSort(state.data, property, newOrder) })));
    };
    const handleRequestCreate = () => {
        // add a new default item, open it up for editing.  Do not add if there is already a "new" item, instead
        // ensure that one is open
        const newIndex = state.data.findIndex((x) => Number(x.id) === 0);
        const overrides = props.makeNewObject ? props.makeNewObject() : {};
        if (newIndex < 0) {
            let newItem = {};
            const newData = [].concat(state.data);
            props.dataDictionary.forEach((field) => {
                newItem[field.id] = field.type === 'number' ? 0 : '';
            });
            newItem.id = 0;
            newItem = Object.assign(Object.assign({}, newItem), overrides);
            newData.unshift(newItem);
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { data: newData })));
        }
    };
    const handleSelectAllClick = (event, checked) => {
        if (checked) {
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { selected: state.data.map((n) => n.id || '') })));
            return;
        }
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { selected: [] })));
    };
    const listAction = (list, id) => {
        const selectedIndex = list.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(list, id);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(list.slice(1));
        }
        else if (selectedIndex === list.length - 1) {
            newSelected = newSelected.concat(list.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(list.slice(0, selectedIndex), list.slice(selectedIndex + 1));
        }
        return newSelected;
    };
    const handleClick = (event, id) => {
        event.stopPropagation();
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { selected: listAction(state.selected, id) })));
    };
    const handleRowClick = (event, id) => {
        if (event) {
            event.stopPropagation();
        }
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { open: listAction(state.open, id) })));
        // if in the 'new' row, delete it
        if (id === 0) {
            const newIndex = state.data.findIndex((x) => Number(x.id) === 0);
            state.data.splice(newIndex, 1);
        }
    };
    const handleSave = (d) => {
        let data = d;
        // Transform the object if requested
        if (props.makeRequestObject) {
            data = props.makeRequestObject(d);
        }
        if (props.onSave) {
            props.onSave(data);
        }
        // delete the item from the 'open' list
        const newIndex = state.data.findIndex((x) => x.id === data.id);
        // If this was the "new" item, delete it completely
        if (data.id === 0 && newIndex >= 0) {
            const newData = [].concat(state.data);
            newData.splice(newIndex, 1);
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { data: newData })));
        }
        const openIndex = state.open.indexOf(data.id);
        if (openIndex >= 0) {
            // create a new open items array without the item given
            const newOpen = [].concat(state.open);
            newOpen.splice(openIndex, 1);
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { open: newOpen })));
        }
    };
    const isSelected = (id) => state.selected.indexOf(id) !== -1;
    const isOpen = (id) => (state.open.indexOf(id) !== -1) || id === 0;
    const showChildrenOfParent = (id) => (state.showChildren.indexOf(id) !== -1);
    const showChildren = (e, id) => {
        e.stopPropagation();
        let newArray = state.showChildren;
        if (showChildrenOfParent(id)) {
            newArray = state.showChildren.filter((x) => x !== id);
        }
        else {
            newArray.push(id);
        }
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showChildren: newArray })));
    };
    const renderDataColumns = ({ level, childData, dataDictionary, item, baseId }) => {
        const row = [];
        let first = true;
        const hasSelected = isSelected(item.id);
        const hasOpen = showChildrenOfParent(item.id);
        if (!props.disableDelete) {
            row.push(<div key={`${baseId}-row-checkbox-${item.id}`} className={classes.checkRow}>
          <Checkbox_1.default color="primary" inputProps={{
                    'aria-label': 'Select Item',
                    id: `${baseId}-row-checkbox`,
                }} sx={{ fontSize: '21px', ml: level * 12 }} className={classes.checkButton} checked={hasSelected} onClick={(event) => handleClick(event, item.id)}/>
        </div>);
        }
        dataDictionary.filter((x) => !x.detailsOnly).forEach((col) => {
            const leftMargin = first ? 12 * level : 0;
            row.push(<Box_1.default key={`qlist_cell:${col.id}-${item[col.id]}`} flex={col.flex} className={classes.rowItem}>
          <Box_1.default fontSize={col.font === 'small' ? '13px' : undefined} textAlign="left" pl={leftMargin} // + (first && 25)
             display="inline-block" id={`${baseId}-row-data-${col.id}`}>
            {col.type === 'custom' ? col.stringToCustom(item[col.id]) : item[col.id] || ''}
          </Box_1.default>
        </Box_1.default>);
            first = false;
        });
        row.push(childData ? (<IconButton_1.default id={`${baseId}-toggle`} aria-label="Expand or Collapse" className={classes.rowChild} sx={{ flex: 0, minWidth: 25 }} key={`qlist_cell_tree:${item.id}`} onClick={(e) => showChildren(e, item.id)} size="large">
          <ExpandLessRounded_1.default sx={{
                transform: hasOpen ? '' : 'scaleY(-1)',
                transition: 'all 0.6s ease',
            }}/>
        </IconButton_1.default>) : (<Box_1.default className={classes.rowChild} width={25} display="inline-block" key={`qlist_cell_tree:${item.id}`}/>));
        return row;
    };
    const renderListItem = ({ level, item, dataDictionary, disableDelete, listIdGenerator }) => {
        const hasSelected = isSelected(item.id);
        const hasOpen = isOpen(item.id);
        const DetailsComponent = props.detailsComponent || QListDetails_1.default;
        let childData = null;
        if (item.children) {
            childData = item.children.map((kid) => renderListItem({
                level: level + 1,
                item: kid,
                dataDictionary,
                disableDelete,
                listIdGenerator: new IdGenerator_1.default(listIdGenerator.getCurrent()),
            }));
        }
        const id = idGenerator.getNext();
        let parentRow = ([
            <react_1.default.Fragment key={`qlist_table:${item.name}${item.id}`}>
        <Paper_1.default sx={{ mb: hasOpen ? 15 : 0 }} elevation={0}>
          <Paper_1.default role="checkbox" aria-checked={hasSelected} tabIndex={-1} key={item.id} elevation={0} className={classes.rowContainer} onClick={(event) => handleRowClick(event, item.id)} sx={{ height: (props === null || props === void 0 ? void 0 : props.rowHeight) ? props.rowHeight : null }}>
            {renderDataColumns({ level, childData, dataDictionary, item, baseId: id })}
          </Paper_1.default>
          {hasOpen && (
                // @ts-expect-error - FIXME: JSX element type
                <DetailsComponent className={classes.details} dataDictionary={dataDictionary} data={item} onEscape={() => handleRowClick(null, item.id)} onSave={handleSave}/>)}
        </Paper_1.default>
      </react_1.default.Fragment>,
        ]);
        if (showChildrenOfParent(item.id) && childData) {
            parentRow = parentRow.concat(childData);
        }
        return parentRow;
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', sizeChanged);
        return () => {
            window.removeEventListener('resize', sizeChanged);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (props.data !== prevData) {
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { data: doSort(props.data, props.defaultSort, state.order) })));
        }
    }, [props.data, props.defaultSort, prevData, state.order]);
    return (<div className={classes.root}>
      <QListToolbar_1.default listName={props.listItemType} numSelected={state.selected.length} onRequestCreate={handleRequestCreate} onValidateRequest={props.onValidateRequest} onDelete={() => {
            if (props.onDelete) {
                props.onDelete(state.selected);
                setState((prevState) => (Object.assign(Object.assign({}, prevState), { selected: [] })));
            }
        }}/>
      <div className={classes.tableWrapper}>
        <div className={classes.table}>
          <div className={classes.header}>
            <QListHeader_1.default numSelected={state.selected.length} order={state.order} orderBy={state.orderBy} onSelectAllClick={handleSelectAllClick} onRequestSort={handleRequestSort} rowCount={state.data.length} columnData={props.dataDictionary.filter((x) => !x.detailsOnly)} disableDelete={props.disableDelete}/>
          </div>
          <div className={classes.rowsSection}>
            {state.data.map((item) => renderListItem({
            level: 0,
            item,
            dataDictionary: props.dataDictionary,
            disableDelete: props.disableDelete,
            listIdGenerator: idGenerator,
        }))}
          </div>
        </div>
      </div>
      <div className={classes.footer}/>
    </div>);
};
exports.default = QList;
